import { QueryKeyParam, createQueryKey } from '../../query';

const merchantKeys = () =>
  createQueryKey({
    all: ['offers', 'merchants'] as const,
    id: (merchantId: QueryKeyParam) =>
      createQueryKey({
        all: ['offers', 'merchants', merchantId] as const,
        detail: ['offers', 'merchants', merchantId, 'detail'] as const,
      }),
  });

export { merchantKeys };
